<div class="admin-home">
    <div class="welcome-section mb-5">
      <h1 class="display-5">Welcome {{ adminUserInfo.userName }}!</h1>
      <p class="lead">Manage your categories, products, and customers easily from here.</p>
    </div>
  
    <div class="row quick-actions">
      <div class="col-md-4 mb-4">
        <div class="card text-center shadow-sm h-100">
          <div class="card-body d-flex flex-column">
            <div class="icon mb-3">
              <i class="bi bi-diagram-3" style="font-size: 2rem;"></i>
            </div>
            <h5 class="card-title">Manage Categories</h5>
            <p class="card-text flex-grow-1">Create, edit, and organize your product categories.</p>
            <a [routerLink]="['/admin/manage-categories']" class="btn btn-primary mt-auto">Go to Categories</a>
          </div>
        </div>
      </div>
  
      <div class="col-md-4 mb-4">
        <div class="card text-center shadow-sm h-100">
          <div class="card-body d-flex flex-column">
            <div class="icon mb-3">
              <i class="bi bi-ui-checks-grid" style="font-size: 2rem;"></i>
            </div>
            <h5 class="card-title">Manage Products</h5>
            <p class="card-text flex-grow-1">Add, update, and manage your product listings.</p>
            <a [routerLink]="['/admin/manage-products']" class="btn btn-primary mt-auto">Go to Products</a>
          </div>
        </div>
      </div>
  
      <div class="col-md-4 mb-4">
        <div class="card text-center shadow-sm h-100">
          <div class="card-body d-flex flex-column">
            <div class="icon mb-3">
              <i class="bi bi-people" style="font-size: 2rem;"></i>
            </div>
            <h5 class="card-title">Manage Customers</h5>
            <p class="card-text flex-grow-1">View and manage customer accounts and activities.</p>
            <a [routerLink]="['/admin/manage-customers']" class="btn btn-primary mt-auto">Go to Customers</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  